export default "__VITE_ASSET__DrHV88xg__"